var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAceTraderred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_246_1471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.359 36C107.32 38.7464 77.7464 68.3196 75 105.359H97.3542C100.469 105.359 102.995 107.885 102.995 111C102.995 114.115 100.469 116.641 97.3542 116.641H75C77.7464 153.68 107.32 183.254 144.359 186V163.646C144.359 160.531 146.885 158.005 150 158.005C153.115 158.005 155.641 160.531 155.641 163.646V186C192.68 183.254 222.254 153.68 225 116.641H202.646C199.531 116.641 197.005 114.115 197.005 111C197.005 107.885 199.531 105.359 202.646 105.359H225C222.254 68.3196 192.68 38.7464 155.641 36V58.3542C155.641 61.4694 153.115 63.9948 150 63.9948C146.885 63.9948 144.359 61.4694 144.359 58.3542V36ZM129.318 111C129.318 107.885 131.843 105.359 134.958 105.359H144.359V95.9583C144.359 92.8431 146.885 90.3177 150 90.3177C153.115 90.3177 155.641 92.8431 155.641 95.9583V105.359H165.042C168.157 105.359 170.682 107.885 170.682 111C170.682 114.115 168.157 116.641 165.042 116.641H155.641V126.042C155.641 129.157 153.115 131.682 150 131.682C146.885 131.682 144.359 129.157 144.359 126.042V116.641H134.958C131.843 116.641 129.318 114.115 129.318 111Z",
    fill: "url(#paint0_linear_246_1471)",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_246_1471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2396 109C31.5464 110.831 11.8309 130.546 10 155.24H24.9028C26.9796 155.24 28.6632 156.923 28.6632 159C28.6632 161.077 26.9796 162.76 24.9028 162.76H10C11.8309 187.454 31.5464 207.169 56.2396 209V194.097C56.2396 192.02 57.9232 190.337 60 190.337C62.0768 190.337 63.7604 192.02 63.7604 194.097V209C88.4536 207.169 108.169 187.454 110 162.76H95.0972C93.0204 162.76 91.3368 161.077 91.3368 159C91.3368 156.923 93.0204 155.24 95.0972 155.24H110C108.169 130.546 88.4536 110.831 63.7604 109V123.903C63.7604 125.98 62.0768 127.663 60 127.663C57.9232 127.663 56.2396 125.98 56.2396 123.903V109ZM46.2118 159C46.2118 156.923 47.8954 155.24 49.9722 155.24H56.2396V148.972C56.2396 146.895 57.9232 145.212 60 145.212C62.0768 145.212 63.7604 146.895 63.7604 148.972V155.24H70.0278C72.1046 155.24 73.7882 156.923 73.7882 159C73.7882 161.077 72.1046 162.76 70.0278 162.76H63.7604V169.028C63.7604 171.105 62.0768 172.788 60 172.788C57.9232 172.788 56.2396 171.105 56.2396 169.028V162.76H49.9722C47.8954 162.76 46.2118 161.077 46.2118 159Z",
    fill: "#F84343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_246_1471",
    x: 67,
    y: 28,
    width: 166,
    height: 166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_246_1471"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_246_1471",
    x: 0,
    y: 99,
    width: 122,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_246_1471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_1471",
    x1: 136.977,
    y1: 93.836,
    x2: 100.253,
    y2: 114.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F84343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAceTraderred);
export default __webpack_public_path__ + "static/media/ACE_Trader(red).50e25dd439d0d11fb53069be4da904f5.svg";
export { ForwardRef as ReactComponent };